export default __webpack_public_path__ + "static/media/notification.72d5668f.wav";